function isTouch() {
  return window.matchMedia('(hover: none)').matches;
}

const initMenuPopup = () => {

  const popupBtn = document.querySelectorAll('.js-popup-btn');
  const popupData = document.querySelectorAll('.js-popup-data');
  const popupItem = document.querySelectorAll('.js-popup-item');

  const loginLink = document.querySelector('.js-login-link');
  const loginModal = document.querySelector('.js-login-modal');
  const loginWrapper = document.querySelector('.login');


  if (popupBtn) {
    for (let i = 0; i < popupBtn.length; i++) {
      popupBtn[i].addEventListener('click', () => {
        popupData[i].classList.toggle('is-active');
      });

      for (let e = 0; e < popupItem.length; e++) {
        popupItem[e].addEventListener('click', () => {
          if (popupData[i].classList.contains('is-active')) {
            popupData[i].classList.remove('is-active');
          }
        });
      }

      window.addEventListener('click', (e) => {
        const target = e.target;
        if (!target.closest('.js-popup-btn') && !target.closest('.js-popup-data')) {
          popupData[i].classList.remove('is-active');
        }
      });
    }
  }

  if (!loginLink) {
    return;
  }

  if (!isTouch()) {
    loginLink.addEventListener('mouseenter', () => {
      loginModal.classList.add('is-active');
    });
    loginWrapper.addEventListener('mouseleave', () => {
      loginModal.classList.remove('is-active');
    });
  }

  if (isTouch()) {
    loginLink.addEventListener('click', () => {
      loginModal.classList.add('is-active');
    });
    document.addEventListener('click', (evt) => {
      const target = evt.target;
      if (loginModal.classList.contains('is-active')) {
        if (target.closest('.js-popup-target') || !target.closest('.login')) {
          loginModal.classList.remove('is-active');
        }
      }
    });
  }
};

export {initMenuPopup};
